import { ssmTokenService } from '@/shared/services/token-service';
import { medicalUserService } from './user-service';
import { JwtService } from './JwtService';

export default class RouterGuardService {

    public pathLogin: string = '/login';
    public pathmain: string = '/main';

    public beforeEnter(to: any, from: any, next: any) {
        if (ssmTokenService.hasToken() && medicalUserService.hasuser()) {
            next();
        } else {
            next(ssmRouterGuardService.pathLogin);
        }
    }


    public IsAdmin(to: any, from: any, next: any) {
        if (ssmTokenService.hasToken() && medicalUserService.hasuser() && JwtService.jwtIsAdmin()) {
            next();
        } else {
            next(ssmRouterGuardService.pathmain);
        }
    }

    public setPathLogin(pathLogin: string) {
        ssmRouterGuardService.pathLogin = pathLogin;
    }

}

export const ssmRouterGuardService = new RouterGuardService();
